import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText } from '@chargify/custom-ui-components';

import { formatCardNumber } from '../helpers';
import { LabelWrapper } from './Label.styles';

type Props = {
  expirationMonth: number;
  expirationYear: number;
  maskedNumber: string;
};

export const Label = ({
  maskedNumber,
  expirationYear,
  expirationMonth,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);
  return (
    <LabelWrapper>
      <BodyText variant={'body1'} fontWeight={600} color={'primary.extraDark'}>
        {t('payment_profile.ending_with', {
          maskedNumber: formatCardNumber(maskedNumber),
        })}
      </BodyText>
      <BodyText variant={'body2'} fontWeight={600} color={'primary.extraDark'}>
        {t('payment_profile.expires', {
          expirationMonth,
          expirationYear,
        })}
      </BodyText>
    </LabelWrapper>
  );
};
